import './App.css';
import ChatBox from './components/chat/ChatBox.js';

function App() {
  return (
    <div className="App">
      <ChatBox />
    </div>
  );
}

export default App;
